export default {
    // 모달/레이어 관련
    modal: {
        logout: {
            title: 'ออกจากระบบ',
            message: 'ต้องการออกจากระบบไหม?',
        },
        confirm: {
            title: 'ยืนยัน',
            message: 'ต้องการดำเนินการต่อจริงหรือไม่?',
        },
    },

    // 드롭다운/셀렉트 관련
    dropdown: {
        selectOption: 'เลือกตัวเลือก',
        noOptions: 'ไม่มีตัวเลือกให้เลือก',
    },

    // 테이블 관련
    table: {
        headers: {
            item: 'รายการ',
            content: 'เนื้อหา',
            activity: 'กิจกรรม',
            mode: 'โหมด',
            result: 'ผลลัพธ์',
            time: 'เวลา',
            student: 'นักเรียน',
            answer: 'คำตอบ',
            score: 'คะแนน',
            status: 'สถานะ',
        },
        noData: 'ไม่มีข้อมูล',
        loading: 'กำลังโหลด...',
    },

    // 폼 관련
    form: {
        required: 'เป็นช่องที่ต้องกรอก',
        invalid: 'รูปแบบไม่ถูกต้อง',
        saved: 'บันทึกแล้ว',
        errors: {
            network: 'เกิดข้อผิดพลาดของเครือข่าย',
            validation: 'กรุณาตรวจสอบข้อมูลที่กรอกอีกครั้ง',
            server: 'เกิดข้อผิดพลาดของเซิร์ฟเวอร์',
        },
    },

    // 로딩/상태 관련
    loading: {
        default: 'กำลังโหลด...',
        saving: 'กำลังบันทึก...',
        processing: 'กำลังประมวลผล...',
        connecting: 'กำลังเชื่อมต่อ...',
    },

    // 알림/토스트 관련
    toast: {
        success: 'ดำเนินการสำเร็จ',
        error: 'เกิดข้อผิดพลาด',
        warning: 'ต้องระวัง',
        info: 'กรุณาตรวจสอบข้อมูล',
    },
};
